// Hardcoded reserved key registry — never store in DB.

export const BROWSER_RESERVED_KEYS: ReadonlySet<string> = new Set([
  "F1", "F5", "F11", "F12",
  "Ctrl+T", "Ctrl+W", "Ctrl+N", "Ctrl+R",
  "Ctrl+F", "Ctrl+L", "Ctrl+P", "Ctrl+S",
  "Ctrl+Shift+I", "Ctrl+Shift+J", "Ctrl+Shift+C",
  "Ctrl+U", "Alt+F4",
]);

export const APP_RESERVED_KEYS: ReadonlySet<string> = new Set([
  "Ctrl+K",
  "Escape",
]);

export const ASSIGNABLE_KEYS: ReadonlyArray<string> = [
  "F2", "F3", "F4", "F6", "F7", "F8", "F9", "F10",
  "Ctrl+1", "Ctrl+2", "Ctrl+3", "Ctrl+4", "Ctrl+5",
  "Ctrl+6", "Ctrl+7", "Ctrl+8", "Ctrl+9",
  "Ctrl+I", "Ctrl+B", "Ctrl+G", "Ctrl+Q",
  "Ctrl+Shift+N", "Ctrl+Shift+T",
];

export type KeyAvailability =
  | { available: true }
  | { available: false; reason: "browser"; label: string }
  | { available: false; reason: "app"; label: string }
  | { available: false; reason: "assigned"; command: string };

export function checkKeyAvailability(
  key: string,
  userShortcuts: Record<string, string>,
  excludeKey?: string,
): KeyAvailability {
  if (BROWSER_RESERVED_KEYS.has(key)) {
    return { available: false, reason: "browser", label: "Reserved by the browser" };
  }
  if (APP_RESERVED_KEYS.has(key)) {
    return { available: false, reason: "app", label: "Used by Helix PSA" };
  }
  const existing = userShortcuts[key];
  if (existing && key !== excludeKey) {
    return { available: false, reason: "assigned", command: existing };
  }
  return { available: true };
}

/** Build a normalized key string ("F2", "Ctrl+Shift+N") from a KeyboardEvent. */
export function keyStringFromEvent(e: KeyboardEvent): string | null {
  const parts: string[] = [];
  if (e.ctrlKey || e.metaKey) parts.push("Ctrl");
  if (e.shiftKey) parts.push("Shift");
  if (e.altKey) parts.push("Alt");
  const k = e.key;
  if (/^F([1-9]|1[0-2])$/.test(k)) {
    parts.push(k);
  } else if (k.length === 1) {
    parts.push(k.toUpperCase());
  } else {
    return null;
  }
  return parts.join("+");
}
